import React, { useEffect, useState } from 'react'
import { Box } from '../../designSystem'
import { ErrorText } from './style'
import AnalyticsChartCreator from './AnalyticsChartCreator'

const Engagement = ({
  bookValidReaders,
  bookReads,
  platformAverageBookReaders,
  bookSelected,
  ChapterListens,
  isSeries = false
}) => {
  const [validReaders, updateValidReaders] = useState(null)
  const [reads, updateReads] = useState(null)
  const [listens, updateListens] = useState(null)
  useEffect(() => {
    if (bookValidReaders?.length > 0) {
      const datasets = [
        {
          label: `${!isSeries ? 'Your Novel Valid Readers %' : 'Your Series Valid Listeners %'}`,
          data: bookValidReaders
            .map((data) => Number(data?.value?.toFixed(2)) || 0)
            .reverse(),
          fill: false,
          backgroundColor: 'rgba(125,197,245,0.67)',
          borderColor: '#2196f3',
        },
      ]
      if (platformAverageBookReaders?.length > 0) {
        datasets.push({
          label: 'Platform Average Novel %',
          data: platformAverageBookReaders.map((data) =>
            Number(data.value.toFixed(2))
          ),
          fill: false,
          backgroundColor: 'rgba(75,133,8,0.57)',
          borderColor: '#4b8508',
        })
      }
      updateValidReaders({
        labels: bookValidReaders.map((data) => `Ch: ${data.chapter}`).reverse(),
        datasets,
      })
    }
    if (bookReads?.length > 0) {
      updateReads({
        labels: bookReads.map((data) => `Ch: ${data.chapter}`).reverse(),
        datasets: [
          {
            label: 'Reads (In Respective Chapter)',
            data: bookReads
              .map((data) => Number(data?.value?.toFixed(2)) || 0)
              .reverse(),
            fill: false,
            backgroundColor: 'rgba(125,197,245,0.67)',
            borderColor: '#2196f3',
          },
        ],
      })
    }
    if (ChapterListens?.length > 0) {
      updateListens({
        labels: ChapterListens.map((data) => `Ch: ${data.chapter}`).reverse(),
        datasets: [
          {
            label: 'Views (In Respective Chapter)',
            data: ChapterListens
              .map((data) => Number(data?.value?.toFixed(2)) || 0)
              .reverse(),
            fill: false,
            backgroundColor: 'rgba(125,197,245,0.67)',
            borderColor: '#2196f3',
          },
        ],
      })
    }
  }, [bookValidReaders, bookReads, platformAverageBookReaders])

  const isMobile = window.screen.width < 600

  if (!validReaders && !reads) {
    return (
      <Box my="8px">
        <ErrorText>
          Data of this category not found, please try again later
        </ErrorText>
      </Box>
    )
  }

  return (
    <>
      {isSeries && validReaders && (
        <AnalyticsChartCreator
          isMobile={isMobile}
          chartTitle="Valid Listeners %"
          chartData={validReaders}
          ToastTxt="% of valid Listeners who heard the respective chapter / Total valid Listeners who heard the series"
          tab="analytics_engagement"
          bookSelected={bookSelected}
          module="validlisteners_infoicon"
        />
      )}
      {isSeries && listens && (
        <AnalyticsChartCreator
          isMobile={isMobile}
          chartTitle="Views"
          chartData={listens}
          ToastTxt="views in respective chapter"
          tab="analytics_engagement"
          bookSelected={bookSelected}
          module="chapterlistens_infoicon"
        />
      )}
      {!isSeries && validReaders && (
        <AnalyticsChartCreator
          isMobile={isMobile}
          chartTitle="Valid Readers %"
          chartData={validReaders}
          ToastTxt="Percentage of valid readers who read the respective chapter / Total valid readers who read the novel"
          tab="analytics_engagement"
          bookSelected={bookSelected}
          module="validreaders_infoicon"
        />
      )}
      {!isSeries && reads && (
        <Box mt={10}>
          <AnalyticsChartCreator
            isMobile={isMobile}
            chartTitle="Reads"
            chartData={reads}
            ToastTxt="Reads in respective chapter selection"
            tab="analytics_engagement"
            bookSelected={bookSelected}
            module="reads_infoicon"
          />
        </Box>
      )}
    </>
  )
}

export default Engagement
